module.exports = require('./helpers/bundle-url').getBundleURL('fW6T3') + "logo-dark.bdeff35f.svg";